import React, { useEffect } from 'react';
import authService from '../../services/AuthService';
import { logger } from '../../services/logger';

export default function SilentRenew() {
    useEffect(() => {
        authService.signinSilentCallback()
            .catch(function (e) {
                logger.error('Silent renew callback failed.', e);
            });
    }, []);

    return (
        <React.Fragment></React.Fragment>
    );
}
